import {
  ChangeDetectorRef,
  OnDestroy,
  Pipe,
  PipeTransform,
} from '@angular/core'
import { fromUtc } from '@helios/utils'
import { formatDistanceToNow } from 'date-fns'

type ExpectedAgoType = string | Date | undefined

const REFRESH_TIME = 1000 * 10

/**
 * Usage: {{ value | ago }}
 * Expected output: "5 minutes"
 *
 * Usage: {{ value | ago:true }}
 * Expected output: "5 minutes ago"
 */
@Pipe({
  name: 'ago',
  pure: false,
})
export class AgoPipe implements PipeTransform, OnDestroy {
  /** @internal */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly interval: any
  private currentValue: ExpectedAgoType = undefined
  private value = ''

  constructor(private readonly _ref: ChangeDetectorRef) {
    // Used to refresh the pipe every 10 seconds
    this.interval = setInterval(() => {
      this.value = this.getFromNow(this.currentValue)
      // Trigger a change detection cycle
      this._ref.markForCheck()
    }, REFRESH_TIME)
  }

  transform(value: ExpectedAgoType, addSuffix: boolean = false): string {
    // Only on first value, so the value doesn't show up 10 seconds late
    if (!this.value) {
      this.value = this.getFromNow(value, addSuffix)
    }

    this.currentValue = value
    // This is the fastest, smallest memory footprint
    return this.value
  }

  ngOnDestroy(): void {
    clearInterval(this.interval)
  }

  private getFromNow(date: ExpectedAgoType, addSuffix = false): string {
    if (!date) return ''
    const utc = fromUtc(date)
    return formatDistanceToNow(utc, { addSuffix })
  }
}
